var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoUnb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 100,
    viewBox: "0 0 200 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.16 36.3573C159.065 43.6347 148.028 49.9416 136.136 55.0863C130.259 57.6283 123.924 59.3859 117.253 60.2205C112.509 60.8131 107.679 61.1114 102.779 61.1114V99.9998H200V14.0879L169.162 36.3604L169.159 36.3573",
    fill: "#008940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8391 36.3573C40.9373 43.6347 51.9722 49.9416 63.8664 55.0863C69.7445 57.6283 76.0757 59.3859 82.7499 60.2205C87.4904 60.8131 92.3212 61.1114 97.224 61.1114V99.9998H0V14.0879L30.8376 36.3604L30.8392 36.3573",
    fill: "#008940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.779 0V55.5549C107.444 55.5549 112.047 55.2672 116.563 54.7082C122.699 53.9396 128.523 52.3242 133.928 49.9876C145.448 45.0052 156.129 38.9006 165.906 31.8513V31.8528L200 7.23003V9.47708e-06H102.779",
    fill: "#133E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.224 0V55.5549C92.554 55.5549 87.9561 55.2672 83.4406 54.7082H83.439C77.3006 53.9396 71.4762 52.3242 66.0713 49.9876C54.5538 45.0052 43.8724 38.9006 34.0928 31.8513V31.8528L0 7.23003V9.47708e-06H97.224",
    fill: "#133E79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUnb);
export default __webpack_public_path__ + "static/media/logo-unb.4a0ba140e37f6ac50fa6d583d5fbb216.svg";
export { ForwardRef as ReactComponent };